import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const EventContentsFilter = ({
    loading = false,
    filters,
    restoreFilterValues,
    options,
}) => (
    <Field
        component={Form.ReduxSelect}
        className='medium'
        name='eventContents'
        placeholder='Content'
        options={options}
        search
        loading={loading}
        multiple
        disabled={loading}
        setValue={restoreFilterValues(filters, 'eventContents')}
        selection
    />
);

EventContentsFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
};
